import { SELECT_VARIANT, REMOVE_CART_ITEM, SET_ALTERNATIVE_PRODUCTS_LINKS } from './action-creators';
import { getCartLineItemsForVariants } from '../../Cart/reducer';
const initialState = { selectedUnits: [], alternativeProductLinks: [] };
const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case SELECT_VARIANT:
            const newUnit = action.newCode;
            const oldUnit = action.oldCode;
            return Object.assign(Object.assign({}, state), { selectedUnits: [...new Set([...state.selectedUnits.filter(u => u !== oldUnit), newUnit].map(unit => unit))] });
        case REMOVE_CART_ITEM:
            const itemUnit = action.code;
            return Object.assign(Object.assign({}, state), { selectedUnits: [...state.selectedUnits.filter(u => u !== itemUnit)] });
        case SET_ALTERNATIVE_PRODUCTS_LINKS:
            const alternativeProductsLinks = action.data;
            return Object.assign(Object.assign({}, state), { alternativeProductLinks: alternativeProductsLinks });
        default:
            return state;
    }
};
export default productReducer;
export const isUnitSelected = (state, code) => state.selectedUnits.includes(code);
export const getOppositeVariant = (cartItems, cartItem) => {
    const oppositeVariantCode = cartItem.product.variants
        .filter(item => item.code !== cartItem.lineItem.selectedVariant.code)
        .shift();
    return (oppositeVariantCode && cartItems.filter(i => i.lineItem.selectedVariant.code === oppositeVariantCode.code).shift());
};
export const getSelectedVariant = (state, variants, preferedVariant) => {
    const cartLineItems = getCartLineItemsForVariants(state, variants);
    if (preferedVariant && cartLineItems.length > 1) {
        return preferedVariant;
    }
    const selectedVariant = variants.find(v => isUnitSelected(state.product, v.code));
    if (selectedVariant) {
        return selectedVariant;
    }
    if (cartLineItems.length > 0) {
        return variants.find(v => v.code === cartLineItems[0].code);
    }
    return variants[0];
};
